module.exports = __webpack_public_path__ + "static/media/netlify-min.de56cda5.jpg";